/**
 * App Router migration note:
 *
 * Page metadata (title/description/OG/canonical) is now produced on the
 * server by `generateMetadata` using the helpers in src/lib/seo.ts, and
 * JSON-LD is rendered by the server pages. GTM and the Facebook pixel
 * moved to src/app/layout.tsx (loaded once via next/script).
 *
 * These components are kept as no-ops so any remaining client view that
 * still renders <Meta .../> keeps compiling. New code should NOT use them.
 */

interface Props {
  title?: string;
  description?: string;
  keyword?: string;
  image?: string;
  slug?: string;
  products?: ProductItemV2[];
  category?: CategoryItem;
}

export function ProductMeta(_props: { product?: ProductDetails }) {
  return null;
}

export function CategoryPageMeta(_props: Props) {
  return null;
}

export const HomePageMeta = () => null;

function Meta(_props: Props) {
  return null;
}

export default Meta;
